const RATING_MIN = 1;

export const transformNumberToRating = ({
  numberValue,
  ratingMax,
}: {
  numberValue: number;
  ratingMax: number;
}): number | null => {
  if (!isFinite(numberValue)) return null;

  numberValue = Math.round(numberValue);
  if (numberValue < RATING_MIN) {
    // null is better than 0, rating 0 transform to others should be null
    return null;
  } else if (numberValue > ratingMax) {
    return ratingMax;
  } else {
    return numberValue;
  }
};
